import MaterialTable from '@material-table/core';
import { CommitModel } from '../../../models/commitModel';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import React, { useCallback } from 'react';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { CONFIGS_PATH } from '../../../routes';

interface Props {
  readonly commitHistory: CommitModel[];
  readonly isLoading: boolean;
}

const CommitHistoryTable = (props: Props) => {
  const navigate = useNavigate();
  const { commitHistory, isLoading } = props;

  const generateTitle = () => {
    if (commitHistory.length > 0) {
      return `History of ${commitHistory.length} last commit(s)`;
    }
    return 'Commit history';
  }

  const renderCreatedDate = useCallback((commit: CommitModel) => {
    return <>{new Date(commit.createdDate).toLocaleString()}</>;
  }, []);

  return (
    <MaterialTable
      title={
        <Stack direction='row' spacing={1} alignItems='center'>
          <IconButton
            aria-label='back to configs view'
            onClick={() => navigate(CONFIGS_PATH)}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant='h5'>{ generateTitle() }</Typography>
        </Stack>
      }
      data={commitHistory}
      isLoading={isLoading}
      columns={[
        {
          title: 'Id',
          field: 'id',
        },
        {
          title: 'Message',
          field: 'message',
        },
        {
          title: 'Author',
          field: 'author',
        },
        {
          title: 'Created date',
          field: 'createdDate',
          render: renderCreatedDate,
        },
      ]}
      options={{
        padding: 'dense',
        selection: false,
        pageSizeOptions: [10, 25, 50],
        pageSize: 10,
        actionsColumnIndex: 6,
        headerStyle: {
          fontWeight: 'bold',
        },
      }}
      components={{
        Container: props => <Paper elevation={1} {...props} />
      }}
    />
  );
};

export default CommitHistoryTable;
